import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { CurrentSelectedRetrievalTypeState } from '../types';

/**
 * 当前选中的检索类型模型
 * @description 存储当前选中的检索类型状态（专利 vs 非专利文献）
 */
export interface CurrentSelectedRetrievalTypeModel extends Model<CurrentSelectedRetrievalTypeState>, Disposable {

}

export const CurrentSelectedRetrievalTypeModel = Symbol.for('CurrentSelectedRetrievalTypeModel');
